/* ==========================================================================
   AWAKENED — theme.js
   No dependencies. Everything degrades gracefully if JS is off:
   forms post normally, links still work, content is visible.
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.AWAKENED && window.AWAKENED.moneyFormat ? window.AWAKENED.moneyFormat : '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString());
  };

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------
     1. Scroll reveal — blurred + offset, then snaps sharp into place
     ------------------------------------------------------------------ */
  function initReveal() {
    var items = $$('.reveal:not(.is-in)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // stagger siblings so a row of cards cascades instead of firing at once
        var group = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--reveal-delay', Math.min(group, 7) * 70 + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     2. Marquee — duplicate the track so the loop is seamless
     ------------------------------------------------------------------ */
  function initMarquee() {
    $$('.marquee__track').forEach(function (track) {
      if (track.dataset.cloned === 'true') return;
      track.dataset.cloned = 'true';
      var html = track.innerHTML;
      track.innerHTML = html + html;
    });
  }

  /* ------------------------------------------------------------------
     3. Cart — AJAX add, drawer, quantity, free-shipping meter
     ------------------------------------------------------------------ */
  var Cart = {
    open: function () {
      var d = $('#cart-drawer'), o = $('#drawer-overlay');
      if (!d) return;
      d.classList.add('is-open');
      if (o) o.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      var close = $('.drawer__close', d);
      if (close) close.focus();
    },
    close: function () {
      var d = $('#cart-drawer'), o = $('#drawer-overlay');
      if (!d) return;
      d.classList.remove('is-open');
      if (o) o.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
    },
    fetch: function () {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json(); });
    },
    add: function (formData, button) {
      var label = button ? button.innerHTML : null;
      if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () {
        return Cart.refresh();
      }).then(function () {
        if (button) { button.disabled = false; button.innerHTML = label; }
        Cart.open();
      }).catch(function (err) {
        if (button) { button.disabled = false; button.innerHTML = label; }
        var msg = (err && err.description) ? err.description : 'Sorry — that item could not be added.';
        alert(msg);
      });
    },
    change: function (line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function () { return Cart.refresh(); });
    },
    refresh: function () {
      return Cart.fetch().then(function (cart) {
        Cart.paintCount(cart.item_count);
        Cart.paintDrawer(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
    },
    paintCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        if (count > 0) el.classList.add('is-bumped');
      });
    },
    paintDrawer: function (cart) {
      var wrap = $('#cart-lines');
      if (!wrap) return;

      if (!cart.items.length) {
        wrap.innerHTML =
          '<div class="drawer__empty"><p>Your bag is empty.</p>' +
          '<p><a class="link-underline" href="/collections/all">Start shopping</a></p></div>';
      } else {
        wrap.innerHTML = cart.items.map(function (item, i) {
          var img = item.image
            ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" loading="lazy" width="76" height="76">'
            : '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="line__variant">' + item.variant_title + '</div>' : '';
          return '' +
            '<div class="line" data-line="' + (i + 1) + '">' +
              '<div class="line__img">' + img + '</div>' +
              '<div>' +
                '<a class="line__name" href="' + item.url + '">' + item.product_title + '</a>' +
                variant +
                '<div class="line__price">' + money(item.final_line_price) + '</div>' +
                '<div class="qty">' +
                  '<button type="button" data-qty="down" aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-qty="up" aria-label="Increase quantity">&plus;</button>' +
                '</div>' +
              '</div>' +
              '<button type="button" class="line__remove" data-qty="remove">Remove</button>' +
            '</div>';
        }).join('');
      }

      var sub = $('#cart-subtotal');
      if (sub) sub.textContent = money(cart.total_price);

      var foot = $('#cart-foot');
      if (foot) foot.hidden = cart.items.length === 0;

      // free shipping meter
      var bar = $('#ship-bar');
      if (bar) {
        var threshold = parseInt(bar.dataset.threshold || '0', 10);
        if (threshold > 0) {
          var remaining = threshold - cart.total_price;
          var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
          $('#ship-fill').style.width = pct + '%';
          $('#ship-label').innerHTML = remaining > 0
            ? 'You\'re <b>' + money(remaining) + '</b> away from free shipping'
            : 'Free shipping unlocked <b>&#10003;</b>';
        } else {
          bar.hidden = true;
        }
      }
    }
  };

  function initCart() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); Cart.refresh(); Cart.open(); return; }

      if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }

      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        var lineEl = qtyBtn.closest('[data-line]');
        if (!lineEl) return;
        var line = parseInt(lineEl.dataset.line, 10);
        var current = parseInt($('.qty span', lineEl).textContent, 10);
        var action = qtyBtn.dataset.qty;
        var next = action === 'up' ? current + 1 : action === 'down' ? current - 1 : 0;
        Cart.change(line, Math.max(0, next));
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      Cart.add(new FormData(form), form.querySelector('[type="submit"]'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { Cart.close(); Popup.close(true); closeMobileNav(); }
    });

    Cart.refresh();
  }

  /* ------------------------------------------------------------------
     4. Newsletter popup + persistent "15% OFF" side tab
     ------------------------------------------------------------------ */
  var STORE_KEY = 'awakened_popup_state';
  var Popup = {
    el: function () { return $('#offer-popup'); },
    tab: function () { return $('#offer-tab'); },
    read: function () {
      try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); }
      catch (e) { return {}; }
    },
    save: function (data) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (e) {}
    },
    open: function () {
      var el = Popup.el();
      if (!el) return;
      el.classList.add('is-open');
      document.body.classList.add('is-locked');
      var tab = Popup.tab();
      if (tab) tab.classList.remove('is-shown');
      var input = $('input[type="email"]', el);
      if (input) setTimeout(function () { input.focus(); }, 420);
    },
    close: function (silent) {
      var el = Popup.el();
      if (!el || !el.classList.contains('is-open')) return;
      el.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      var state = Popup.read();
      state.dismissedAt = Date.now();
      Popup.save(state);
      Popup.showTab();
      if (!silent) { /* nothing extra */ }
    },
    showTab: function () {
      var tab = Popup.tab();
      if (tab && !Popup.read().subscribed) tab.classList.add('is-shown');
    },
    boot: function () {
      var el = Popup.el();
      if (!el) return;
      var state = Popup.read();
      var delay = parseInt(el.dataset.delay || '2500', 10);
      var days = parseInt(el.dataset.frequency || '7', 10);
      var expired = !state.dismissedAt || (Date.now() - state.dismissedAt) > days * 86400000;

      if (state.subscribed) return;                 // already on the list
      if (expired) { setTimeout(Popup.open, delay); }
      else { Popup.showTab(); }
    }
  };

  function initPopup() {
    Popup.boot();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) { e.preventDefault(); Popup.close(); return; }
      if (e.target.closest('[data-popup-open]')) { e.preventDefault(); Popup.open(); return; }
      if (e.target.closest('[data-tab-dismiss]')) {
        e.preventDefault(); e.stopPropagation();
        var tab = Popup.tab();
        if (tab) tab.classList.remove('is-shown');
        return;
      }
      var overlay = e.target.closest('.popup-overlay');
      if (overlay && !e.target.closest('.popup')) Popup.close();
    });

    // Shopify redirects back with ?customer_posted=true on success
    if (/customer_posted=true/.test(window.location.search)) {
      var state = Popup.read();
      state.subscribed = true;
      Popup.save(state);
      var tab = Popup.tab();
      if (tab) tab.classList.remove('is-shown');
    }
  }

  /* ------------------------------------------------------------------
     5. FAQ accordion
     ------------------------------------------------------------------ */
  function initFaq() {
    document.addEventListener('click', function (e) {
      var q = e.target.closest('.faq__q');
      if (!q) return;
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      var isOpen = q.getAttribute('aria-expanded') === 'true';
      var group = q.closest('.faq');

      if (group && group.dataset.single === 'true' && !isOpen) {
        $$('.faq__q', group).forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var p = document.getElementById(other.getAttribute('aria-controls'));
          if (p) p.classList.remove('is-open');
        });
      }
      q.setAttribute('aria-expanded', String(!isOpen));
      if (panel) panel.classList.toggle('is-open', !isOpen);
    });
  }

  

  /* ------------------------------------------------------------------
     7. Product page — gallery + variant picker
     ------------------------------------------------------------------ */
  function initProduct() {
    $$('[data-pdp]').forEach(function (root) {
      var data = null;
      var script = $('[data-variants]', root);
      try { data = JSON.parse(script.textContent); } catch (e) { return; }

      var mainImg = $('[data-pdp-main] img', root);
      $$('[data-thumb]', root).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          $$('[data-thumb]', root).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImg) {
            mainImg.src = thumb.dataset.full;
            mainImg.srcset = '';
          }
        });
      });

      var selected = [];
      $$('[data-option-index]', root).forEach(function (group) {
        var idx = parseInt(group.dataset.optionIndex, 10);
        var active = $('.opt__value.is-active', group);
        selected[idx] = active ? active.dataset.value : null;
      });

      function findVariant() {
        return data.filter(function (v) {
          return selected.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0];
      }

      function paint() {
        var variant = findVariant();
        var idInput = $('[data-variant-id]', root);
        var priceEl = $('[data-pdp-price]', root);
        var btn = $('[data-add]', root);

        if (!variant) {
          if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          priceEl.innerHTML = variant.compare_at_price && variant.compare_at_price > variant.price
            ? '<span class="is-sale">' + money(variant.price) + '</span> <s>' + money(variant.compare_at_price) + '</s>'
            : money(variant.price);
        }
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? (btn.dataset.label || 'Add to bag') : 'Sold out';
        }
        if (variant.featured_image && mainImg) {
          mainImg.src = variant.featured_image.src;
          mainImg.srcset = '';
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      $$('.opt__value', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-option-index]');
          var idx = parseInt(group.dataset.optionIndex, 10);
          $$('.opt__value', group).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selected[idx] = btn.dataset.value;
          paint();
        });
      });

      paint();
    });
  }

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */
  function boot() {
    initReveal();
    initMarquee();
    initCart();
    initPopup();
    initFaq();
    initProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-run when the theme editor swaps a section in
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initMarquee(); initProduct(); Cart.refresh();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#offer-popup')) Popup.open();
  });

  window.AwakenedCart = Cart;
})();
